/**
 * Width (in spacing-scale steps) of the drag-handle slot inside a template card header — the
 * drag-indicator icon at its default size. The slot is reserved whenever reordering is available,
 * even while a card's handle is hidden, so the header content keeps the same left edge.
 */
export const DRAG_HANDLE_GUTTER_WIDTH = 6;
